export class CredentialsModel {
  username: string;
  password: string;
  recaptchaToken?: string;
  email: string;

  constructor() {
    this.username = '';
    this.password = '';
    this.email = '';
  }
}
